import MaterialTable from "material-table";
import React, { forwardRef, useEffect, useState } from "react";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { Typography } from "@mui/material";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const headerStyle = {
  backgroundColor: "#039be5",
  color: "#FFF",
};

const HBBPlansCategoryTable = ({ tableRespoonse }) => {
  const [tableList, setTableList] = useState([]);

  useEffect(() => {
    if (tableRespoonse) {
      const listOmantel = [];
      const listNormal = [];
      const listWfbb = [];
      let grandTotal = {};

      for (let key in tableRespoonse) {
        if (key == "GRAND TOTAL") {
          for (let type in tableRespoonse?.[key]) {
            grandTotal.labels = key;
            grandTotal[type] = tableRespoonse?.[key][type];
            grandTotal.type = "heading";
          }
          continue;
        } else {
          for (let subkey in tableRespoonse?.[key]) {
            let data = { labels: subkey };

            for (let type in tableRespoonse?.[key][subkey]) {
              data[type] = tableRespoonse?.[key][subkey][type];
              data.type = key;
            }
            if (key == "OMANTEL - OBC") {
              listOmantel.push(data);
            }
            if (key == "NORMAL ACTIVATION") {
              listNormal.push(data);
            }
            if (key == "WFBB-HBB") {
              listWfbb.push(data);
            }
          }
        }
      }
      const omantel = {
        labels: "OMANTEL - OBC",
        COPPER: 0,
        FIBER: 0,
        OBC: 0,
        Blank: 0,
        total: 0,
        "Voice Only": 0,
        type: "heading",
      };
      const normal = {
        labels: "NORMAL ACTIVATION",
        COPPER: 0,
        FIBER: 0,
        OBC: 0,
        Blank: 0,
        total: 0,
        "Voice Only": 0,
        type: "heading",
      };
      const wfbb = {
        labels: "WFBB-HBB",
        COPPER: 0,
        FIBER: 0,
        OBC: 0,
        Blank: 0,
        total: 0,
        "Voice Only": 0,
        type: "heading",
      };

      listOmantel.map((item) => {
        omantel.COPPER = omantel.COPPER + (item?.COPPER ?? 0);
        omantel.Blank = omantel.Blank + (item?.Blank ?? 0);
        omantel.FIBER = omantel.FIBER + (item?.FIBER ?? 0);
        omantel.OBC = omantel.OBC + (item?.OBC ?? 0);
        omantel.total = omantel.total + (item?.total ?? 0);
        omantel["Voice Only"] =
          omantel["Voice Only"] + (item?.["Voice Only"] ?? 0);
      });
      listNormal.map((item) => {
        normal.COPPER = normal.COPPER + (item?.COPPER ?? 0);
        normal.Blank = normal.Blank + (item?.Blank ?? 0);
        normal.FIBER = normal.FIBER + (item?.FIBER ?? 0);
        normal.OBC = normal.OBC + (item?.OBC ?? 0);
        normal.total = normal.total + (item?.total ?? 0);
        normal["Voice Only"] =
          normal["Voice Only"] + (item?.["Voice Only"] ?? 0);
      });
      listWfbb.map((item) => {
        wfbb.COPPER = wfbb.COPPER + (item?.COPPER ?? 0);
        wfbb.Blank = wfbb.Blank + (item?.Blank ?? 0);
        wfbb.FIBER = wfbb.FIBER + (item?.FIBER ?? 0);
        wfbb.OBC = wfbb.OBC + (item?.OBC ?? 0);
        wfbb.total = wfbb.total + (item?.total ?? 0);
        wfbb["Voice Only"] = wfbb["Voice Only"] + (item?.["Voice Only"] ?? 0);
      });

      console.log("wfbb", { wfbb, normal, omantel, grandTotal });

      const list = [
        omantel,
        ...listOmantel,
        normal,
        ...listNormal,
        wfbb,
        ...listWfbb,
        grandTotal,
      ];

      console.log("list", list);
      setTableList(list);
    }
  }, [tableRespoonse]);

  const renderCell = (data, field) => {
    return (
      <div>
        {data?.type == "heading" ? (
          <Typography fontWeight="600">{data?.[field]}</Typography>
        ) : (
          <Typography marginLeft={field == "labels" ? "10px" : "0px"}>
            {data?.[field]}
          </Typography>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "auto",
        direction: "ltr",
      }}
    >
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: "Row Labels",
            field: "labels",
            headerStyle,
            render: (data) => renderCell(data, "labels"),
          },
          {
            title: "COPPER",
            field: "COPPER",
            headerStyle,
            render: (data) => renderCell(data, "COPPER"),
          },
          {
            title: "FIBER",
            field: "FIBER",
            headerStyle,
            render: (data) => renderCell(data, "FIBER"),
          },
          {
            title: "OBC",
            field: "OBC",
            headerStyle,
            render: (data) => renderCell(data, "OBC"),
          },
          {
            title: "Voice Only",
            field: "Voice Only",
            headerStyle,
            render: (data) => renderCell(data, "Voice Only"),
          },
          {
            title: "Blank",
            field: "Blank",
            headerStyle,
            render: (data) => renderCell(data, "Blank"),
          },
          {
            title: "Grand total",
            field: "total",
            headerStyle,
            render: (data) => renderCell(data, "total"),
          },
        ]}
        data={tableList}
        title={
          <h2>{/* <IntlMessages tagName="strong" id="Companies" /> */}</h2>
        }
        options={{
          search: false,
          paging: false,
        }}
      />
    </div>
  );
};

export default HBBPlansCategoryTable;
